// extracted by mini-css-extract-plugin
export default {"root":"root_root__NEw4q","mainContainer":"root_mainContainer__qQ--2"};